import {
    Button, Card, Input, Space,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import Table from '../components/table';
import { useNotifications } from '../hooks/useNotifications';
import { INotification } from '../types/notification';

function NotificationsPage() {
    const { data, loading, resend } = useNotifications();
    const [params, setParams] = useSearchParams();
    const { t } = useTranslation();

    const actions = (record: INotification) => (
        <Button
            disabled={!record.error}
            title={t('repeat') as string}
            type="primary"
            icon={<ReloadOutlined />}
            size="small"
            onClick={() => resend(record)}
        />
    );

    const extra = (
        <Space>
            <Link to="/notification/create">
                <Button icon={<PlusOutlined />} type="primary" />
            </Link>
            <Input.Search
                allowClear
                defaultValue={params.get('search') || undefined}
                placeholder="Поиск..."
                onSearch={(val) => {
                    params.set('search', val);
                    params.set('page', '1');
                    setParams(params);
                }}
            />
        </Space>
    );

    return (
        <Card title={t('notifications')} extra={extra}>
            <Table
                bordered
                loading={loading}
                dataSource={data?.list}
                pagination={{
                    current: data?.currentPage,
                    pageSize: data?.perPage,
                    showSizeChanger: false,
                    total: data?.total,
                }}
                columns={[
                    {
                        align: 'center',
                        dataIndex: 'id',
                        title: '№',
                    },
                    {
                        align: 'center',
                        dataIndex: 'order_id',
                        title: t('orderNumber'),
                        render: (value) => (value !== null ? <Link to={`/order/${value}`}>{value}</Link> : '-'),
                    },
                    {
                        align: 'center',
                        dataIndex: 'tracking_code',
                        title: t('rusPostCodes'),
                    },
                    {
                        align: 'center',
                        dataIndex: 'title',
                        title: t('title'),
                    },
                    {
                        align: 'center',
                        dataIndex: 'message',
                        title: t('message'),
                        render: (value: string) => (<span dangerouslySetInnerHTML={{ __html: value || '' }} />),
                    },
                    {
                        align: 'center',
                        dataIndex: 'recipient',
                        title: t('orderRecipient'),
                    },
                    {
                        align: 'center',
                        dataIndex: 'type',
                        title: t('messageType'),
                    },
                    {
                        align: 'center',
                        dataIndex: 'destination',
                        title: t('destinationType'),
                    },
                    {
                        align: 'center',
                        dataIndex: 'status',
                        title: t('status'),
                    },
                    {
                        align: 'center',
                        dataIndex: 'created_at',
                        title: t('creationDate'),
                    },
                    {
                        align: 'center',
                        render: actions,
                    },
                ]}
            />
        </Card>
    );
}

export default NotificationsPage;
